<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load processed files"
    data-testid="warrants-files-processed"
    searchable
    search-placeholder="Search file name"
    :filters="warrantsFilesProcessedTableFilters"
    :fetcher="fetchFiles"
    :items-from="itemsFrom"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import {
    createdAtColumn,
    idColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsFilesProcessedListResult,
    WarrantsFilesProcessedService,
  } from "@/services/admin/WarrantsFilesProcessedService"
  import {
    warrantsFilesProcessedTableFilters,
    WarrantsFilesProcessedTableFilters,
  } from "@/views/admin/warrants/warrantsFilesConfig"

  const headers: SoDataTableHeader[] = [
    idColumn,
    {
      title: "File Name",
      key: "fileName",
      sortable: true,
      sortKey: "file_name",
    },
    { title: "Folder", key: "folder", sortable: true },
    {
      title: "File Type",
      key: "fileTypeDisplay",
      sortable: true,
      sortKey: "file_type",
    },
    {
      title: "DCA Type",
      key: "dcaTypeDisplay",
      sortable: true,
      sortKey: "dca_type",
    },
    createdAtColumn,
  ]

  export default defineComponent({
    components: {
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
        warrantsFilesProcessedTableFilters,
      }
    },
    methods: {
      fetchFiles({
        search,
        filters,
        page,
        pageSize,
        orderBy,
      }: SoDataTableOptions<WarrantsFilesProcessedTableFilters>) {
        return WarrantsFilesProcessedService.getFiles(
          search,
          {
            fileType: filters.fileType.value,
            dcaType: filters.dcaType.value,
          },
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsFilesProcessedListResult) {
        return result.files
      },
    },
  })
</script>
